
    import { defineComponent } from 'vue';
    import LaravelPagination from '@/components/widgets/LaravelPagination/LaravelPagination.vue'

    export default defineComponent({
        components: {
            LaravelPagination,
        },
        emits: ['ok', 'cancel'],
        props: {
            excludedKeys: Array,
            primaryKey: String,
            text: String,
            title: String,
            okBtn: String,
            multiple: Boolean,
            searchPath: String,
            cancelBtn: String,
            enableX: {
                type: Boolean,
                default: true
            }
        },
        data: function() {
            return {
                searchString: '',
                config: {
                    url: this.searchPath,
                    method: 'get',
                    excludedKeys: this.excludedKeys
                },
                selected: [] as Object[],
                loading: true
            }
        },
        methods: {
            okPressed() {
                if (this.primaryKey && !this.multiple) {
                    this.$emit('ok', (this as any).selected[0][this.primaryKey]);
                    return;
                }
                if (this.primaryKey && this.multiple) {
                    const values: Object[] = [];
                    for (const item of this.selected) {
                        values.push(item[this.primaryKey as keyof Object]);
                    }
                    this.$emit('ok', values);
                    return;
                }
                this.$emit('ok', null);
            },

            setSelected(selected: any) {
                if (!this.multiple)
                {
                    this.selected = [] as Object[];
                }
                this.selected.push(selected);
            },

            unselected(selected: any) {
                this.selected.splice(this.selected.indexOf(selected), 1);
            },
        },
        mounted() {
        },
    });
